angular
  .module('mooney', ['ngResource', 'ngRoute'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when(CONFIG.url.mooney.failure(), {controller: 'MooneyFailCtrl', template: ' '})
      .when(CONFIG.url.mooney.method(), {
        controller: 'MooneyMethodCtrl',
        templateUrl: '/r/static/templates/mooney/method.html',
      })
      .when(CONFIG.url.mooney.charge(), {
        controller: 'MooneyChargeCtrl',
        templateUrl: '/r/static/templates/mooney/charge.html',
      })
  }])
  .factory('Mooney', ['$resource', function ($resource) {
    var Mooney = $resource(
      CONFIG.api('mooney'),
      {},
      {
        set_method: {method: 'POST', params: {id: 'set_method'}},
        balance_pay: {method: 'POST', params: {id: 'balance_pay'}},
      },
    )
    return Mooney
  }])

function set_notification($scope) {
  const mediaType = (($scope.mooney.price_rows || [])[0] || {}).type
  const extraText =
    $scope.mooney.context.toLowerCase() === 'invoice' && mediaType !== 'pdf'
      ? '<br>' + _('HTML_notification_invoice_addrecips_note')
      : ''
  $scope.notify.set(
    $scope,
    _(
      'HTML_notification_mooney_' +
        $scope.mooney.context.toLowerCase() +
        '_' +
        (mediaType == 'pdf' ? 'created' : 'sent') +
        '_free_or_balance',
      {
        // NB: We hope to be able to get the number of sent msgs from the first row of price_rows.
        // NB: This logic is also in mooney/models.py.
        _n: (($scope.mooney.price_rows || [])[0] || {}).count,
        url: CONFIG.url.log.receipts(),
      },
    ) + extraText,
  )
}

/* Controllers */

angular.module('mooney').controller('MooneyChargeCtrl', ['$scope', '$routeParams', '$location', 'Mooney', function ($scope, $routeParams, $location, Mooney) {
  $scope.utils.setPageTitle(_('mooney_title'))
  $scope.utils.setPageID('default')

  var final_goto = $location.search()['goto']

  Mooney.get(
    {
      id: $routeParams.id,
      goto: final_goto,
    },
    // success handler
    function (data) {
      $scope.mooney = data
      // If this payment has already been paid then redirect, otherwise embed the payment options
      if ($scope.mooney.paid || parseFloat($scope.mooney['amount']) === 0) {
        set_notification($scope)
        $location.path(window.a4base + $scope.mooney['goto'])
      } else {
        if ($scope.mooney.pmt_method == 'paytrail') {
          // load the widget script only on demand
          a4.loaded($scope)
        } else {
          // Balance so 'load' right away
          a4.loaded($scope)
        }
      }
    },
    // error handler
    a4.restErrorFactory($scope),
  )

  $scope.backToMethod = function () {
    if ($scope.mooney.context == 'Balance') {
      $location.path(CONFIG.url.balance.buy())
    } else {
      $location.path(CONFIG.url.mooney.method($routeParams.id))
    }
  }
}])

angular.module('mooney').controller('MooneyMethodCtrl', ['$scope', '$routeParams', '$location', 'Mooney', function ($scope, $routeParams, $location, Mooney) {
  $scope.utils.setPageTitle(_('mooney_title'))
  $scope.utils.setPageID('default')

  var final_goto = $location.search()['goto']
  $scope.must_pick_method = false
  $scope.method = undefined

  Mooney.get(
    {
      id: $routeParams.id,
      goto: final_goto,
    },
    // success handler
    function (data) {
      $scope.mooney = data
      // If this payment has already been paid then redirect, otherwise embed the payment options
      if ($scope.mooney.paid || parseFloat($scope.mooney['original_amount']) === 0) {
        set_notification($scope)
        $location.path(window.a4base + $scope.mooney['goto'])
      } else {
        $scope.must_pick_method = true
        a4.loaded($scope)
        var sizeTimer = setInterval(function () {
          let $panels = $('.panel')
          if ($panels.eq(0).height() === $panels.eq(1).height()) {
            clearInterval(sizeTimer)
          }
          $panels.height(Math.max($panels.eq(0).height(), $panels.eq(1).height()))
        }, 5)
      }
    },
    // error handler
    a4.restErrorFactory($scope),
  )

  // Update the mooney row with the missing payment details
  $scope.set_method = function (method) {
    $scope.method = method
    $scope._sending = true

    Mooney.set_method(
      {
        mid: $routeParams.id,
        method: method,
      },
      // success handler
      function (data) {
        if (method === 'balance') {
          Mooney.balance_pay(
            {
              balance_mid: parseInt($routeParams.id),
            },
            function (data) {
              set_notification($scope)
              $location.path(window.a4base + $scope.mooney['goto'])
            },
            a4.restErrorFactory($scope),
          )
        } else {
          // go to balance_trail provider selection
          $location.path(CONFIG.url.mooney.charge($routeParams.id))
        }
      },
      a4.restErrorFactory($scope),
    )
  }

  $scope.is_under_minimum = function () {
    if (!$scope.settings || !$scope.mooney) {
      return true
    }

    return parseFloat($scope.mooney.original_amount) < parseFloat($scope.settings.prices_.pt_minimum)
  }

  $scope.has_balance = function () {
    if (!$scope.settings || !$scope.mooney) {
      return false
    }

    return parseFloat($scope.settings.balance_) >= parseFloat($scope.mooney.original_amount)
  }
}])

angular.module('mooney').controller('MooneyFailCtrl', ['$scope', '$routeParams', '$location', 'Mooney', function ($scope, $routeParams, $location, Mooney) {
  $scope.utils.setPageTitle(_('mooney_title'))
  $scope.utils.setPageID('invoices')

  $scope.notify.set($scope, _('HTML_notification_mooney_failure'))
  // extracts mooney_id from checkout-reference:
  $location.path(CONFIG.url.mooney.charge($location.search()['checkout-reference'].split('-')[2]))
}])
